import { CustomerNoteBody } from "../CustomersTable/CustomerNoteBody";
import { stripMentionTokens } from "../../utils/customerNoteMentions";

type ReceivablesNotesCellProps = {
  notes: string;
};

export function ReceivablesNotesCell({ notes }: ReceivablesNotesCellProps) {
  if (!notes || notes === "-") {
    return <>{notes}</>;
  }

  return (
    <span title={stripMentionTokens(notes)}>
      <CustomerNoteBody body={notes} />
    </span>
  );
}
